module["exports"] = ["Kat #", "Stan ##"];